<template>
    <div class="ur-data-grid__accordion--default">
        <ur-form-box class="ur-data-grid__accordion--form">
            <ur-form-item v-for="f in fields" :label="getTitle(f)" :key="f.value"
                    v-ur-tooltip.overflow.empty="getValue(f)">
                <div class="ellipsis" v-ur-tooltip.overflow="getValue(f)">{{getValue(f)}}</div>
            </ur-form-item>
        </ur-form-box>
    </div>
</template>

<script>
import {dateToText} from '../../../util'

export default {
    name : "urDataGridContentAccordionDefault",
    inject : ['gridInfo'], 
    props : {
        row: {type:Object}
    },
    computed : {
        fields() {return this.gridInfo.cols}
    },
    methods : {
        getTitle(f) {
            if(!f){return '';}
            if(!f.text){return f.value+"#";}
            if(typeof f.text === 'function') {
                return f.text();
            } else {
                return f.text
            }
        },
        getValue(f) {
            var cv = f.customValue, v = this.row[f.value];
            if(cv && typeof cv ==='function') {
                return cv(v, this.row);
            }
            switch(f.type) {
            case 'date':
                const fmt = f.dateFormat || this.gridInfo.opts.dateFormat;
                const timezone = f.timezone===null ? this.gridInfo.opts.timezone : f.timezone;
                return v?dateToText(v, fmt, timezone):''
            case 'code':
                if(f.__domainMap) {
                    var dobj = f.__domainMap.get(v);
                    return dobj?dobj.text:v;
                }
                break;
            default:
                break;
            }
            return v;
        }
    }
}
</script>